import React from "react";
import WidgetContainer from "components/WidgetContainer/WidgetContainer";

import "./InThePressMediaKitDownloadWidget.css";

import IconOne from "images/inthepress/icon-1.svg";
import IconTwo from "images/inthepress/icon-2.svg";
import IconThree from "images/inthepress/icon-3.svg";
import DownloadIcon from "images/inthepress/download-arrow.svg";

const InThePressMediaKitDownloadWidget = () => {
    return (
        <WidgetContainer>
            <div className="itp-media-kit">
                <h2>Media Kit</h2>
                <p>Downloadable assets for your communication</p>
                <div className="itp-media-kit-main-content">
                    <a
                        href="https://website.phonepe.com/assets/press/tile-1/Press-Releases.zip"
                        className="itp-media-kit-main-content__item"
                        id="card-one"
                        title="Press releases"
                    >
                        <div>
                            <img src={IconOne} alt="setting icon" />
                        </div>
                        <div className="itp-media-kit-main-content__item__title">
                            <h3>
                                Press Releases <br />
                                <span>
                                    Download the latest PhonePe Press Releases
                                </span>
                            </h3>
                            <p>
                                <img src={DownloadIcon} alt="download icon" />
                            </p>
                        </div>
                    </a>
                    <a
                        className="itp-media-kit-main-content__item"
                        id="card-two"
                        href="https://website.phonepe.com/assets/press/tile-2/Graphics-Images.zip"
                        title="PhonePe logo & graphics"
                    >
                        <div>
                            <img src={IconTwo} alt="camera icon" />
                        </div>
                        <div className="itp-media-kit-main-content__item__title">
                            <h3>
                                Standard Graphics and Image Gallery <br />
                                <span> Download the PhonePe logo here</span>
                            </h3>
                            <p>
                                <img src={DownloadIcon} alt="download icon" />
                            </p>
                        </div>
                    </a>
                    <a
                        className="itp-media-kit-main-content__item"
                        id="card-three"
                    ></a>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default InThePressMediaKitDownloadWidget;
